import { useRef, useEffect } from 'react'
import { type AlmanacCableSubscription } from 'providers/CableConsumer/types'
import useIsMounted from 'ismounted'
import { useWebsocketConnection } from 'providers/WebsocketProvider'

interface CreationMessage {
  session_uuid: string
  external_integration_id: number
}

const useExternalIntegrationsRealtime = ({
  workspaceId,
  onMessage,
}: {
  workspaceId: number | undefined
  onMessage: (message: CreationMessage) => void
}) => {
  const isMounted = useIsMounted()
  const websocketConnection = useWebsocketConnection()
  const externalIntegrationsSubscription = useRef<AlmanacCableSubscription>()

  useEffect(() => {
    if (!websocketConnection || !workspaceId || !isMounted.current) return

    externalIntegrationsSubscription.current = websocketConnection.subscriptions.create(
      { channel: 'ExternalIntegrations::CreateChannel', workspace_id: workspaceId },
      { received: onMessage },
    )

    return () => {
      externalIntegrationsSubscription?.current?.unsubscribe()
    }
  }, [onMessage, workspaceId, isMounted, websocketConnection])
}

export { useExternalIntegrationsRealtime }
